import {NgModel} from './ngModel';

export const Employer = NgModel.extend({
    _name: 'Employer',
});
